"use client";

import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Forbidden() {
  return (
    <div className="flex items-center justify-center bg-background h-[85vh]">
      <div className="text-center space-y-6 p-8 max-w-md">
        <div className="flex justify-center">
          <AlertCircle className="h-24 w-24 text-destructive" />
        </div>
        <h1 className="text-4xl font-bold tracking-tight">Access Denied</h1>
        <p className="text-muted-foreground">
          Sorry, you don&apos;t have permission to access this page. If you
          believe this is an error, please contact the administrator.
        </p>
        <div className="flex justify-center space-x-4">
          <Button asChild>
            <Link to="/">Home</Link>
          </Button>
          <a href="mailto:rohit@8090.inc">
            <Button variant="outline" disabled aria-disabled="true">
              Contact Support
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
